import { useMutation } from '@tanstack/react-query';
import {
  IPAContentEventParams,
  onDonePAMaterial,
} from '../../queries/DailySchedule/scheduleContent';

export function useDoneMaterial() {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (params: IPAContentEventParams) => onDonePAMaterial(params),
  });

  return {
    mutateAsync,
    isPending,
  };
}
